/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
 import react,{useState} from "react";
import axios from 'axios';
 function ImageUpload(){
const [image, setimage]=useState(" ")
const handleChange=(e)=>{
    //console.log(e.target.files)
    setimage(e.target.files[0])
}
const handleApi=()=>{
    const url=''
    const formData=new formData()
    formData.append('image,image')
    axios.post(url,formData).then((res)=>{
     
})}
 return(
     <div>
         <input type='file' onChange={handleChange}></input>
         {/* <button onClick={handleApi}></button> */}
     </div>
 )
}
export default ImageUpload